import { FormInput, PrimaryButton } from '@systemeio/ui'
import { createTag } from 'modules/tags/api/tags-api'
import { TagCreateInterface, TagInterface } from 'modules/tags/types/tag-interface'
import { useState } from 'react'
import CreateModal, { CreateDataType } from 'shared/components/create-modal'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { fetchWithErrors } from 'shared/utils/fetch-with-errors'

export interface CreateNewTagModalProps {
  onCreate: (newTag: TagInterface) => Promise<void>
}

interface ErrorsInterface {
  name: string
}
const defaultErrors = { name: '' }

export const CreateNewTagModal = ({ onCreate }: CreateNewTagModalProps) => {
  const { t } = useLocoTranslation()

  const [isOpened, setIsOpened] = useState<boolean>(false)
  const [errors, setErrors] = useState<ErrorsInterface>(defaultErrors)

  const onCreateTag = async (data: CreateDataType<{ name: TagCreateInterface['name'] }>) => {
    await fetchWithErrors(async () => {
      const { data: newTag } = await createTag({ name: data?.name })
      await onCreate(newTag)
    }, setErrors)
  }

  const onClose = () => {
    setIsOpened(false)
    setErrors(defaultErrors)
  }

  return (
    <>
      <PrimaryButton
        onClick={() => {
          setIsOpened(true)
        }}
      >
        {t('dashboard.tag.create_tag_button.label')}
      </PrimaryButton>
      <CreateModal
        opened={isOpened}
        onClose={onClose}
        defaultValues={{ name: '' }}
        caption={t('dashboard.tag.title')}
        creatable={[
          {
            field: 'name',
            onRender: (value, onChange) => (
              <FormInput
                key="tag-name-create"
                label={t('dashboard.tag.tag_name')}
                placeholder={t('global.name')}
                value={value}
                onChange={e => onChange(e.target.value)}
                maxLength={256}
                error={errors.name}
              />
            ),
          },
        ]}
        onCreate={onCreateTag}
        requiredFields={['name']}
      />
    </>
  )
}
